<template>
    <z-tabs size="m">
        <template v-slot:label>
            <z-tabs-label
                v-for="tab in hearingData"
                :key="tab.value"
                :id="tab.value"
            >
                {{ tab.value }}
            </z-tabs-label>

        </template>
        <template v-slot:content>
            <z-tabs-content
                v-for="tabContent in hearingData"
                :key="tabContent.value"
                :id="tabContent.value"
            >
                <z-accordion v-if="tabContent.value === '2024'" class="u-bottom-margin--l-important">
                    <z-accordion-item id="mine">
                        <template v-slot:header>«Рудник «Масловский». Объекты общественных обсуждений.</template>
                        <template v-slot:body>
                            <z-accordion nested>
                                <z-accordion-item id="intersite-roads">
                                    <template v-slot:header>«Рудник «Масловский». Очередь&nbsp;1. Вскрытие и&nbsp;отработка запасов Северного участка. Межплощадочные автомобильные дороги».</template>
                                    <template v-slot:body>
                                        <z-filelist>
                                            <spoiler>
                                                <template v-slot:default>
                                                    <z-filelist-item
                                                        name="«Проектная документация «Рудник «Масловский». Очередь&nbsp;1. Вскрытие и отработка запасов Северного участка. Межплощадочные автомобильные дороги», включая предварительные материалы оценки воздействия на окружающую среду»"
                                                        href="/upload/files/ru/public-hearings100424.zip"
                                                        icon-name="file/zip"
                                                        file-size="444,45 Мб"
                                                        date="10.04.2024"
                                                    />
                                                    <z-filelist-item
                                                        name="Журнал учета замечаний&nbsp;и предложений общественности"
                                                        href="/upload/files/ru/sustainability/environment/public-hearings/opros-100424.pdf"
                                                        icon-name="file/pdf"
                                                        file-size="105 Кб"
                                                        date="10.04.2024"
                                                    />
                                                </template>
                                            </spoiler>
                                        </z-filelist>
                                    </template>
                                </z-accordion-item>
                            </z-accordion>
                        </template>
                    </z-accordion-item>
                </z-accordion>

                <z-filelist>
                    <z-filelist-item
                        v-for="(item, jIndex) in tabContent.items"
                        :key="`${jIndex}-${item.name}-${item.activeFrom}`"
                        :name="item.name"
                        :icon-name="`file/${item.file.type}`"
                        :file-size="item.file.size"
                        :date="item.activeFrom"
                        :href="item.file.link"
                    />
                </z-filelist>
            </z-tabs-content>
        </template>
    </z-tabs>
</template>
<script>
import { publicHearingData } from './publicHearingData'
export default {
    name: 'PublicHearingComponent',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            hearingData: this.data.length ? this.data : publicHearingData
        }
    },
    computed: {
    }
}
</script>
